import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addNotification } from "../../../store/slices/notificationsSlice";
import IconButton from "@mui/material/IconButton";
import Badge from '@mui/material/Badge';
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { getSocket } from "../../../utils/initiate_socket";
import { ReactComponent as BellNotificationIcon } from '../../../assets/Bell_Icon.svg'


export default function NotificationDropdown() {
    const [anchorEl, setAnchorEl] = useState(null);
    const dispatch = useDispatch();
    const notifications = useSelector(state => state.notifications.messages);
    const trigger = useSelector(state => state.notifications.socketStatus);
    const [bellFlag, setBellFlag] = useState(false);

    useEffect(() => {
        let socket = getSocket();

        if (socket) {
            socket.onopen = () => {
                socket.send(JSON.stringify({ action: 'ping' }));
            };
            socket.onmessage = (event) => {
                const obj = JSON.parse(event.data);
                if (obj.type === 'notification') {
                    setBellFlag(true);
                    dispatch(addNotification(obj.message));
                }
                if (event.data === "success") {
                    socket.close();
                }
            };
        }
        return () => {
            if (socket) socket.close();
        };
    }, [dispatch, trigger]);

    const handleMenuOpen = (event) => {
        setBellFlag(false);
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton color="inherit" aria-label="notifications" onClick={handleMenuOpen}>
                <Badge color="warning" variant="dot" invisible={!bellFlag} >
                    <BellNotificationIcon/>
                </Badge>
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
                PaperProps={{ style: { width: "250px" } }}
            >
                {notifications.length === 0 ? (
                    <MenuItem disabled>No notifications</MenuItem>
                ) : (
                    notifications.map((note, idx) => (

                        <MenuItem key={idx} onClick={handleMenuClose} style={{ whiteSpace: "break-spaces"}}>{note}</MenuItem>
                    ))
                )}
            </Menu>
        </>
    );
}
